import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { ApiService } from '../../../../services/api/api.service';
import { NbToastrService } from '@nebular/theme';

@Component({
  selector: 'app-partial-emails-selector',
  templateUrl: './partial-emails-selector.component.html',
  styleUrls: ['./partial-emails-selector.component.css']
})
export class PartialEmailsSelectorComponent implements OnInit {
  private requisitionId: any;
  private requisitionPartialId: any;
  public loading: boolean;
  public partialEmails: any;
  constructor(public config: DynamicDialogConfig, public ref: DynamicDialogRef,
    private apiService: ApiService,
    private messageService?: NbToastrService) {
    if (config && config.data && config.data.requisitionId) {
      this.requisitionId = config.data.requisitionId;
      this.loadReqEmails();
    }

    if (config && config.data && config.data.requisitionPartialId) {
      this.requisitionPartialId = config.data.requisitionPartialId;
      this.loadReqPartialEmails();
    }



  }

  ngOnInit() {
  }

  public loadReqEmails() {
    this.loading = true;
    this.partialEmails = new Array();
    this.apiService.post(`/api/requisitionPartial/emailsPerReq/${this.requisitionId}`)
      .subscribe(results => {
        this.partialEmails = results;
        this.loading = false;

        if (results.length == 0)
          this.ref.close();
      }, err => {
        this.messageService.danger("Could not load", "Action");
        this.loading = false;
      });
  }

  public loadReqPartialEmails() {
    this.loading = true;
    this.partialEmails = new Array();
    this.apiService.post(`/api/requisitionPartial/emails/${this.requisitionPartialId}`)
      .subscribe(results => {
        this.partialEmails = results;
        this.loading = false;
        if (results.length == 0)
          this.ref.close();
      }, err => {
        this.messageService.danger("Could not load", "Action");
        this.loading = false;
      });
  }

  public save() {
    this.ref.close(this.getFormattedData());
  }

  public send() {

  }

  public cancel() {
    this.ref.close();
  }

  public getFormattedData() {
    return this.partialEmails.map(o => ({
      supplierId: o.supplierId, emails: o.emails.filter(function (i) {
        return i.selected
      }).map(o => o.value)
    }))
  }

  public isNotCustom(email) {
    if (typeof email.custom == undefined)
      return true;
    else return false;
  }
}
